var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("img", {
          staticClass: "imgageproperty",
          attrs: { src: require("@/assets/img/errorlist.png"), alt: "icon" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("COO Assignments")) + " ")
      ]),
      _c(
        "v-row",
        { staticClass: "pa-0 ma-0 mt-4 searchArea" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex align-center pb-0",
              attrs: { cols: "12", md: "2" }
            },
            [
              _c(
                "v-menu",
                {
                  attrs: {
                    "offset-y": "",
                    "close-on-content-click": false,
                    "content-class": "columnMenu"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "manage-btn btn",
                                  attrs: { text: "", small: "" }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Manage Columns")) + " "
                              ),
                              _c(
                                "v-icon",
                                {
                                  class: { rotate: _vm.menuOpen },
                                  attrs: { right: "" }
                                },
                                [_vm._v("mdi-chevron-down")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menuOpen,
                    callback: function($$v) {
                      _vm.menuOpen = $$v
                    },
                    expression: "menuOpen"
                  }
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "column-card" },
                    [
                      _c("v-card-title", { staticClass: "column-header" }, [
                        _vm._v(_vm._s(_vm.$t("Select Columns")))
                      ]),
                      _c("v-divider"),
                      _c(
                        "v-list",
                        { staticClass: "select-all", attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value": _vm.isAllSelected,
                                  "hide-details": ""
                                },
                                on: { change: _vm.toggleSelectAll }
                              }),
                              _c("v-list-item-title", [
                                _vm._v(_vm._s(_vm.$t("Select All")))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-text",
                        { staticClass: "column-list" },
                        [
                          _c(
                            "v-list",
                            { attrs: { dense: "" } },
                            _vm._l(
                              _vm.tableHeaders.filter(function(h) {
                                return h.value !== "labelCode"
                              }),
                              function(header) {
                                return _c(
                                  "v-list-item",
                                  { key: header.value },
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        value: header.text,
                                        "hide-details": ""
                                      },
                                      model: {
                                        value: _vm.visibleColumns,
                                        callback: function($$v) {
                                          _vm.visibleColumns = $$v
                                        },
                                        expression: "visibleColumns"
                                      }
                                    }),
                                    _c(
                                      "v-list-item-title",
                                      { staticClass: "column-text" },
                                      [_vm._v(_vm._s(header.text))]
                                    )
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-divider"),
                      _c(
                        "v-card-actions",
                        { staticClass: "column-footer" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: {
                                background: "#c57171",
                                color: "#fff!important",
                                width: "80px"
                              },
                              attrs: { color: "error", text: "", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                          ),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticStyle: { width: "80px" },
                              attrs: { color: "primary", small: "" },
                              on: {
                                click: function($event) {
                                  _vm.menuOpen = false
                                  _vm.SaveVisibleColumns()
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Save")) + " ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-none d-md-flex align-center justify-center pa-0",
              staticStyle: { "align-self": "end" },
              attrs: { cols: "1" }
            },
            [
              _c("v-divider", {
                staticStyle: { "min-height": "40px" },
                attrs: { vertical: "" }
              })
            ],
            1
          ),
          _c(
            "v-col",
            {
              staticClass: "d-flex align-end py-0 coo-search-row",
              attrs: { cols: "12", md: "9" }
            },
            [
              _c("v-text-field", {
                staticClass: "form-input coo-field",
                attrs: {
                  label: _vm.$t("Label ID"),
                  placeholder: _vm.$t("Input Label ID"),
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                  clearable: ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search(1)
                  }
                },
                model: {
                  value: _vm.searchBy.labelId,
                  callback: function($$v) {
                    _vm.$set(_vm.searchBy, "labelId", $$v)
                  },
                  expression: "searchBy.labelId"
                }
              }),
              _c("v-text-field", {
                staticClass: "form-input coo-field",
                attrs: {
                  label: _vm.$t("Product ID"),
                  placeholder: _vm.$t("Input Product ID"),
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                  clearable: ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search(1)
                  }
                },
                model: {
                  value: _vm.searchBy.productId,
                  callback: function($$v) {
                    _vm.$set(_vm.searchBy, "productId", $$v)
                  },
                  expression: "searchBy.productId"
                }
              }),
              _c("v-text-field", {
                staticClass: "form-input coo-field",
                attrs: {
                  label: _vm.$t("COO"),
                  placeholder: _vm.$t("Input COO"),
                  outlined: "",
                  dense: "",
                  "hide-details": "",
                  clearable: ""
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search(1)
                  }
                },
                model: {
                  value: _vm.searchBy.coo,
                  callback: function($$v) {
                    _vm.$set(_vm.searchBy, "coo", $$v)
                  },
                  expression: "searchBy.coo"
                }
              }),
              _c(
                "v-btn",
                {
                  staticClass: "btn type-search coo-btn",
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      return _vm.search(1)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Search")))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn type-search coo-btn",
                  attrs: { text: "" },
                  on: {
                    click: function($event) {
                      return _vm.clear()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Clear")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-data-table",
        {
          staticClass: "tbl-type01 mt-10",
          attrs: {
            headers: _vm.filteredHeaders,
            items: _vm.tableItems,
            "item-key": "labelCode",
            "hide-default-footer": true,
            options: _vm.options,
            "server-items-length": _vm.totalRecords,
            "show-select": ""
          },
          on: {
            "update:options": function($event) {
              _vm.options = $event
            }
          },
          scopedSlots: _vm._u(
            [
              {
                key: "item.battery",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "span",
                      {
                        class:
                          item.battery === "GOOD" ? "txt-stable" : "txt-danger"
                      },
                      [_vm._v(_vm._s(item.battery))]
                    )
                  ]
                }
              },
              {
                key: "item.networkStatus",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "", "content-class": "tooltip-content" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "div",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "d-flex justify-center"
                                        },
                                        "div",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("div", {
                                        staticClass: "status-dot",
                                        class: item.networkStatus
                                          ? "online"
                                          : "offline"
                                      })
                                    ]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(item.networkStatus ? "ONLINE" : "OFFLINE")
                            )
                          )
                        ])
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.status",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("span", { class: _vm.statusStyle(item.status) }, [
                      _vm._v(_vm._s(item.status))
                    ])
                  ]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.selected,
            callback: function($$v) {
              _vm.selected = $$v
            },
            expression: "selected"
          }
        },
        [
          _c("template", { slot: "no-data" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("No data available")))])
          ])
        ],
        2
      ),
      _c("div", { staticClass: "table-options" }, [
        _c(
          "div",
          [
            _c("BlinkPopup", {
              attrs: {
                selectedLabel: _vm.selectedLabel,
                btnDisabledBlinking:
                  _vm.btnDisabledBlinking || _vm.checkSelected
              },
              on: { fireResetLabel: _vm.resetSelection }
            }),
            _c(
              "v-btn",
              {
                staticClass: "btn ml-2",
                attrs: {
                  disabled:
                    _vm.tableItems.length === 0 || _vm.btnDisabledExport,
                  text: ""
                },
                on: { click: _vm.exportList }
              },
              [_vm._v(" " + _vm._s(_vm.$t("Export")) + " ")]
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c("Pagination", {
              attrs: {
                pageInfoText: _vm.pageInfoText,
                pageIndex: _vm.pageIndex,
                rowPerPage: _vm.rowPerPage,
                goToPageInput: _vm.goToPageInput,
                totalPages: _vm.totalPages
              },
              on: {
                paging: function($event) {
                  return _vm.paging($event)
                },
                updatePage: function($event) {
                  return _vm.updatePage($event)
                }
              }
            })
          ],
          1
        )
      ]),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }